import React, { useEffect, useState, useRef } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { FiMenu, FiX, FiChevronDown, FiChevronRight } from "react-icons/fi";
import { getServicesList } from "services/serviceslist/services";
import "./Header.scss";

const CustomHeader = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [servicesDropdown, setServicesDropdown] = useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);
  const [servicesList, setServicesList] = useState([]);
  const [servicesActive, setServicesActive] = useState(false);

  const dropdownRef = useRef(null);
  const location = useLocation();

  const slugify = (text) =>
    text.toString().toLowerCase().trim().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-");

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setServicesDropdown(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    setServicesActive(location.pathname.startsWith("/service"));
  }, [location]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setMobileMenuOpen(false);
        setMobileServicesOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await getServicesList({ page: 1, limit: 50 });
        if (res?.code === 200) setServicesList(res.data.services || []);
      } catch (err) {
        console.error(err);
      }
    };
    fetchServices();
  }, []);

  return (
    <>
      {/* HEADER */}
      <header className={`custom_header ${scrolled ? "custom_scrolled" : ""}`}>
        <div className="custom_container">
          <div className="header_inner">
            <div className="logo_wrap">
              <Link to="/"><img src="/assets/icons/sahyoglogofull.png" alt="Logo" /></Link>
            </div>

            <ul className="desktop_nav">
              <li><NavLink to="/" className="nav_item">Home</NavLink></li>
              <li><NavLink to="/about-us" className="nav_item">About</NavLink></li>

              <li className="nav_item dropdown_parent" ref={dropdownRef}>
                <span
                  className={`nav_item dropdown_trigger ${servicesActive ? "active" : ""}`}
                  onClick={() => setServicesDropdown(!servicesDropdown)}
                >
                  Services <FiChevronDown className="dropdown_icon" />
                </span>

                <div className="dropdown_area">
                  <ul className={`services_dropdown ${servicesDropdown ? "show" : ""}`}>
                    {servicesList.length === 0 ? (
                      <li className="dropdown_empty">No services available</li>
                    ) : (
                      servicesList.map((srv) => (
                        <li key={srv.id}>
                          <NavLink
                            to={`/service/${slugify(srv.title)}`}
                            onClick={() => setServicesDropdown(false)}
                          >
                            <FiChevronRight className="service_icon" /> {srv.title}
                          </NavLink>
                        </li>
                      ))
                    )}
                  </ul>
                </div>
              </li>

              <li><NavLink to="/gallery" className="nav_item">Gallery</NavLink></li>
              <li><NavLink to="/careers" className="nav_item">Careers</NavLink></li>
              <li><NavLink to="/contactus" className="nav_item">Contact</NavLink></li>
              <li><NavLink to="/blogs" className="nav_item">Blogs</NavLink></li>
            </ul>

            {/* Mobile Hamburger */}
            <div className="mobile_hamburger" onClick={() => setMobileMenuOpen(true)}>
              <FiMenu size={28} />
            </div>
          </div>
        </div>
      </header>

      {/* MOBILE MENU */}
      <div className={`premium_mobile_sidebar ${mobileMenuOpen ? "open" : ""}`}>
        <div className="mobile_sidebar_header">
          <h2>Menu</h2>
          <FiX className="close_icon" onClick={() => setMobileMenuOpen(false)} />
        </div>

        <div className="mobile_links_wrapper">
          <Link to="/" onClick={() => setMobileMenuOpen(false)}>Home</Link>
          <Link to="/about-us" onClick={() => setMobileMenuOpen(false)}>About</Link>

          {/* Services Expand */}
          <div className="mobile_dropdown_group">
            <div 
              className="mobile_dropdown_trigger"
              onClick={() => setMobileServicesOpen(!mobileServicesOpen)}
            >
              <span>Services</span>
              <FiChevronDown className={`arrow ${mobileServicesOpen ? "rotate" : ""}`} />
            </div>

            {mobileServicesOpen && (
              <div className="mobile_dropdown_box">
                {servicesList.map((srv) => (
                  <Link
                    key={srv.id}
                    to={`/service/${slugify(srv.title)}`}
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    <FiChevronRight /> {srv.title}
                  </Link>
                ))}
              </div>
            )}
          </div>

          <Link to="/gallery" onClick={() => setMobileMenuOpen(false)}>Gallery</Link>
          <Link to="/careers" onClick={() => setMobileMenuOpen(false)}>Careers</Link>
          <Link to="/contactus" onClick={() => setMobileMenuOpen(false)}>Contact</Link>
          <Link to="/blogs" onClick={() => setMobileMenuOpen(false)}>Blogs</Link>
        </div>
      </div>

      {/* OVERLAY */}
      <div
        className={`premium_overlay ${mobileMenuOpen ? "show" : ""}`}
        onClick={() => setMobileMenuOpen(false)}
      ></div>
    </>
  );
};

export default CustomHeader;
